/* @todo(kai) temporary place for this modifiers */

module.exports = function (fox) {
    'use strict';
    fox.registerTemplateModifier('strToInt', function (obj) {
        return fox.isString(obj) ? parseInt(obj) : 0;
    });

    fox.registerTemplateModifier('isNull', function (obj) {
        return fox.isNull(obj);
    });

    fox.registerTemplateModifier('isNotNull', function (obj) {
        return !fox.isNull(obj);
    });

    fox.registerTemplateModifier('hideIfTrue', function (obj) {
        return obj === true && '_hidden' || '';
    });

    fox.registerTemplateModifier('hideIfFalse', function (obj) {
        return obj === false && '_hidden' || '';
    });
};


//////////////////
// WEBPACK FOOTER
// ../common/dependencies/modifiers.js
// module id = 403
// module chunks = 2